export default __webpack_public_path__ + "static/media/103_zipzap_kawai_0001.0d8ca216.png";